export default __webpack_public_path__ + "static/break-33d1b771213df4ec442dc2f00bb0b616.png";